import { handleRequest } from "../utilities/requestHandler";

export const getRoleUsers = (roleId) =>
    handleRequest("get", `/roles/${roleId}/users`);

export const deleteRoles = (selectedRows, reassignTo = null, reassignMap = null) => {
    const payload = { selected_rows: selectedRows };
    if (reassignTo !== null) {
        payload.reassign_to = reassignTo;
    }
    if (reassignMap && typeof reassignMap === "object") {
        payload.reassign_map = reassignMap;
    }
    return handleRequest("post", "/roles/delete", payload);
};

export const duplicateRole = (roleId, newName) =>
    handleRequest("post", "/roles/duplicate", { role_id: roleId, new_name: newName });
